import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import { useStyles } from "../../common/appStyles";
import { ThemeProvider, createTheme } from '@mui/material';

/**
 * @param props - allows user to click yes or no in order to confirm their submission.
 * @returns - a Dialog with text and two buttons on it (yes and no).
 * @remarks The Confirm box is for allowing a user to make sure they are submitting
 */
export function ConfirmBox(props) {
    const { handleSubmit, handleClose, showDialog } = props;
    const classes = useStyles();

    const theme = createTheme({
        palette: {
            primary: {
                main: '#10AD61'
            },
            secondary: {
                main: '#10AD61'
            },
            background: {
                default: '#ffffff'
            },
        },
        typography: {
            h6: {
                color: '#484A57'
            },
            h4: {
                color: '#484A57'
            },
            body1: {
                color: 'black'
            }
        },
    });

    const handleConfirm = () => {
        handleSubmit();
    }

    return (
        <div>
            <ThemeProvider theme={theme}>
                <Dialog
                    open={showDialog}
                    onClose={handleClose}
                    fullWidth
                    maxWidth={'xs'}
                >
                    <Grid container alignItems={"center"} justifyContent={'center'}>
                        <Grid item>
                            <Grid
                                container
                                className={classes.subWrapper4}
                                direction={"column"}
                                justifyContent={'center'}
                                alignItems={"center"}
                                rowSpacing={2}
                            >
                                <Grid item xl={12}>
                                    <Grid container direction={'column'} className={classes.gridPadding} >
                                        <Grid item>
                                            <Typography align='center'>
                                                <h4>Are you sure you want to submit?</h4>
                                            </Typography>
                                            <Typography variant='body1' align='center'>
                                                Once submitted, you will <b>NOT</b> be able
                                                to make another submission until after the judging process has concluded.
                                            </Typography>
                                        </Grid>
                                    </Grid>
                                </Grid>
                                <Grid item xl={12}>
                                    <Grid container direction={"row"} justifyContent={'space-evenly'} alignItems={'center'} columnSpacing={3}>
                                        <Grid item xs={6}>
                                            <Button onClick={handleConfirm} variant='contained' fullWidth>
                                                Yes
                                            </Button>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Button onClick={handleClose} variant='contained' fullWidth>
                                                No
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Dialog >
            </ThemeProvider>
        </div >
    );
}